import React, { useState, useEffect } from 'react'
import {
  Card, CardHeader, CardBody,
  Form, FormGroup, FormFeedback,
  Label, Input, CustomInput
} from 'reactstrap'
import _ from 'lodash'

import getDomainURL from 'utils/api'
import Lang from 'Lang/General'

const SenderSettings = ({
  emailTemplates,
  errorMessageEmailTemplate,
  errorMessageCenter,
  onChangeEmailTemplateHOC,
  onChangeCenterHOC,
  selectedLanguage,
  ... props
}) => {
  const [ isReadMore, setIsReadMore ] = useState( true )
  const [ isCustomDomain, setIsCustomDomain ] = useState( true )
  const { center: selectedCenter } = props.data.selectCenterReducer.selectedCenter

  useEffect( () => {
    selectedCenter && 
    setIsCustomDomain( DEFAULT_MG_SENDER_EMAIL_ADDRESS !== selectedCenter.sender_email )
  }, [ selectedCenter ] )
  
  return(
    <Card className='mt-3'>
      <CardHeader>{ Lang[ 'SENDER_SETTINGS' ][ selectedLanguage ] }</CardHeader>
      <CardBody>
        {
          selectedCenter?.email_api_service === 'mailgun' && (
            <>
              <CustomInput
                id='is-custom-domain'
                type='checkbox'
                checked={ isCustomDomain }
                label={ Lang[ 'USE_MY_OWN_DOMAIN' ][ selectedLanguage ] }
                className='mb-3'
                onChange={ e => {
                  setIsCustomDomain( e.target.checked )
                  onChangeCenterHOC( 
                    'selectedCenter',
                    {
                      ...selectedCenter,
                      sender_email: !e.target.checked 
                        ? DEFAULT_MG_SENDER_EMAIL_ADDRESS
                        : ''
                    }
                  )
                  onChangeEmailTemplateHOC( 
                    'emailTemplates',
                    {
                      ...emailTemplates,
                      sender_name: !e.target.checked ? 'No Reply' : '',
                      reply_email: '',
                      mailgun_domain: ''
                    }
                  )
                }} 
              />
              {
                isCustomDomain && (
                  <FormGroup>
                    <Label className='mb-0' >{ Lang[ 'EMAIL_DISPATCH_DOMAIN' ][ selectedLanguage ] }</Label>
                    <p style={{ fontSize: '13px' }}>{ Lang[ 'EMAIL_DOMAIN_DESCRIPTION' ][ selectedLanguage ] }</p>
                    <Input
                      type='text'
                      value={ emailTemplates.mailgun_domain }
                      onChange={ e => onChangeEmailTemplateHOC( 'emailTemplates', { ...emailTemplates, mailgun_domain: e.target.value } )} />
                  </FormGroup>
                )
              }
            </>
          )
        }
        <p style={{ fontSize: '13px'}}>
          {
            isReadMore 
              ? `${ Lang[ 'SENDER_EMAIL_CONFIGURATION_SUBHEADING' ][ selectedLanguage ].slice(0, 100)}... ` 
              : Lang[ 'SENDER_EMAIL_CONFIGURATION_SUBHEADING' ][ selectedLanguage ] + ' '
          }
          <span onClick={ () => setIsReadMore( !isReadMore )} style={{ color: 'blue', cursor: 'pointer' }}>
            { isReadMore ? Lang[ 'VIEW_MORE' ][ selectedLanguage ] : Lang[ 'SHOW_LESS' ][ selectedLanguage ] }
          </span>
        </p>
        {
          console.log(selectedCenter)
        }
        {
          !_.isEmpty( selectedCenter ) && (
            <Form>
              <FormGroup>
                <Label>{ Lang[ 'SENDER_EMAIL' ][ selectedLanguage ] }</Label>
                <Input
                  type="text"
                  value={ emailTemplates.sender_email }
                  onChange={ e => {
                    onChangeEmailTemplateHOC( 
                      'emailTemplates', 
                      { ...emailTemplates, sender_email: e.target.value }
                    )
                  }}
                  invalid={ 
                    errorMessageCenter.sender_email || 
                    (
                      !_.isEmpty( emailTemplates.sender_email ) &&
                      !EMAIL_PATTERN.test( emailTemplates.sender_email )
                    )
                  } />
                <FormFeedback>{ Lang[ 'PLEASE_ENTER_VALID_EMAIL' ][ selectedLanguage ] }</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>{ Lang[ 'SENDER_NAME' ][ selectedLanguage ] }</Label>
                <Input
                  type="text"
                  value={ emailTemplates.sender_name }
                  onChange={ e => {
                    onChangeEmailTemplateHOC( 
                      'emailTemplates', 
                      { ...emailTemplates, sender_name: e.target.value }
                    )
                  }}
                  invalid={ errorMessageEmailTemplate.sender_name } />
                <FormFeedback>{ Lang[ 'ENTER_SENDER_NAME' ][ selectedLanguage ] }</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>{ Lang[ 'REPLY_EMAIL' ][ selectedLanguage ] }</Label>
                <Input
                  type="text"
                  value={ emailTemplates.reply_email }
                  onChange={ e => {
                    onChangeEmailTemplateHOC( 
                      'emailTemplates', 
                      { ...emailTemplates, reply_email: e.target.value }
                    )
                  }}
                  invalid={
                    errorMessageEmailTemplate.reply_email || 
                    (
                      !_.isEmpty( emailTemplates.reply_email ) &&
                      !EMAIL_PATTERN.test( emailTemplates.reply_email )
                    )
                  } />
                <FormFeedback>{ Lang[ 'PLEASE_ENTER_VALID_EMAIL' ][ selectedLanguage ] }</FormFeedback>
              </FormGroup>
            </Form>
          )
        }
      </CardBody>
    </Card>
  )
}

const EMAIL_PATTERN = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i )

const DEFAULT_MG_SENDER_EMAIL_ADDRESS = `noreply@${ getDomainURL( '' ).substring( getDomainURL( '' ).indexOf( '.' ) + 1 ) }`

export default SenderSettings